import { computed, type MaybeRefOrGetter } from 'vue'

import { useSearchQueryStore } from '../stores/search.query-store'

export const useSearch = () => {
  const queryStore = useSearchQueryStore()

  const createSearchQuery = (searchQuery: MaybeRefOrGetter<string>) => {
    // Create search items query
    const itemsQuery = queryStore.createSearchItemsQuery(searchQuery)

    // Extract product IDs for lessons
    const productIds = computed(() => {
      const items = itemsQuery.data.value || []
      return [...new Set(items.filter(item => item.type !== 'product' && item.productId).map(item => item.productId))]
    })

    // Fetch product titles for lessons
    const titlesQuery = queryStore.createProductTitlesQuery(productIds)

    return {
      searchItems: itemsQuery.data,
      isLoading: itemsQuery.isLoading,
      isFetching: itemsQuery.isFetching,
      isPending: itemsQuery.isPending,
      error: itemsQuery.error,
      productTitles: titlesQuery.data,
    }
  }

  return {
    createSearchQuery,
  }
}
